import React from 'react';
import {Box, Typography} from '@mui/material';
import './Demo.scss';
import {Link} from 'react-router-dom';

const Demo: React.FC = () => {
  interface DemoLink {
    path: string;
    label: string;
  }

  const demoLinks: DemoLink[] = [
    {path: '/demo/components/navigation-list', label: 'Navigation List Demo'},
    {path: '/demo/components/action-button', label: 'Action Button Demo'},
    // {path: '/demoproductionapi', label: '🧪 Production API Testing Suite'}, // Hidden - access directly via /demoproductionapi
    {path: '/demo/components/collapsiblePanel', label: 'Callapsible Panel'},
    {path: '/demo/components/accordion', label: 'Accordion'},
    {path: '/demo/components/floating-panel', label: 'Floating Panel Demo'},
    {path: '/demo/components/document-tile', label: 'Document Tile'},
    {path: '/demo/components/banner', label: 'Banner'},
    {path: '/demo/components/data-grid', label: 'Grid Demo'},
    {path: '/demo/components/datepicker', label: 'Date Picker'},
    {path: '/demo/components/date-time-picker', label: 'Date Time Picker'},
    {path: '/demo/components/drawer', label: 'Drawer'},
    {path: '/demo/components/iconbutton', label: 'Icon Button'},
    {path: '/demo/components/icon-button', label: 'Icon Button'},
    {path: '/demo/components/linechart', label: 'LineChart'},
    {path: '/demo/components/menu', label: 'Menu Demo'},
    {path: '/demo/components/modal', label: 'Modal'},
    {path: '/demo/components/pagination', label: 'Pagination'},
    {path: '/demo/components/select-dropdown', label: 'Select Dropdown'},
    {path: '/demo/components/textfield', label: 'TextField'},
    {path: '/demo/components/toast', label: 'Toast'},
    {path: '/demo/components/tooltip', label: 'Tooltip'},
    {path: '/demo/components/tooltip-wrapper', label: 'Tooltip with popover'},
    {path: '/demo/components/transfer-list', label: 'Transfer List'},
    {path: '/demo/components/verticalnavbar', label: 'Vertical Navbar'},
    {path: '/demo/components/widget-wrapper', label: 'Widget Wrapper'},
    {path: '/demo/components/loading-spinner', label: 'Loading Spinner'},
    {path: '/demo/components/filter-chip', label: 'Filter Chip'},
    {path: '/demo/components/piechart', label: 'Pie Chart'},
    {path: '/demo/components/funnel-chart', label: 'Funnel Chart'},
    {path: '/demo/components/linear-progressbar', label: 'Linear Progressbar'},
    {path: '/demo/components/tree-view', label: 'Tree view'},
    {path: '/demo/components/radio', label: 'Radio'},
    {path: '/demo/components/checkbox', label: 'Checkbox'},
    {path: '/demo/components/toggle', label: 'Toggle'},
    {path: '/demo/components/pagination-pro', label: 'PaginationPro'},
    {path: '/demo/components/codingform-editor', label: 'Coding Form Editor'},
    {path: '/demo/components/WizardStepper', label: 'Wizard Stepper'},
    {
      path: '/demo/components/bar-chart-selectable',
      label: 'Bar Chart Selectable',
    },
    {
      path: '/demo/components/selectable-column-chart',
      label: 'Selctable Column Chart',
    },
    {path: '/demo/components/select-source', label: 'Select Source'},
    {path: '/demo/components/selection-chip', label: 'Selection Chip'},
    {path: '/demo/components/numeric-input', label: 'Numeric Input'},
    {
      path: '/demo/components/accordion-with-checkbox',
      label: 'Accordion With Checkbox',
    },
    {path: '/demo/components/text-area', label: 'Text Area'},
    {path: '/demo/components/time-input', label: 'Time Input (ArrTimePicker)'},
    {path: '/demo/components/checkbox-list', label: 'Checkbox List'},
    {path: '/demo/components/arr-slider', label: 'ArrSlider'},
    {path: '/demo/components/filterAccordion', label: 'Filter Accordion'},
    {path: '/demo/components/bar-chart', label: 'Bar Chart'},
    {path: '/demo/components/split-panel', label: 'Split Panel'},
    {path: '/demo/components/thumbnail', label: 'Thumbnail'},
    {path: '/demo/components/popout-panel', label: 'Popout Panel'},
    {
      path: '/demo/components/wait-to-complete-modal',
      label: 'Wait To Complete Modal',
    },
    {
      path: '/demo/components/tree-item-selector',
      label: 'Tree Item Selector',
    },
    {
      path: '/demo/components/search-progress-dialog',
      label: 'Search Progress Dialog',
    },
    {path: '/demo/components/result-tile', label: 'Search Result Tile'},
    {
      path: '/demo/components/tile-selection',
      label: 'Tile Selection',
    },
    {
      path: '/demo/components/rich-text-editor',
      label: 'Rich Text Editor',
    },
    {
      path: '/demo/components/AIThinkingLoader',
      label: 'AI Thinking Loader',
    },
    {path: '/demo/components/Metrics', label: 'AI Review Metrics'},
    {
      path: '/demo/components/AIReviewJobDetails',
      label: 'AI Review Job Details',
    },
  ];

  const sortedLinks = [...demoLinks].sort((a, b) =>
    a.label.localeCompare(b.label)
  );

  return (
    <Box className="demo-page">
      <Typography className="typo-text headline1_size">
        Common Components
      </Typography>
      <br />
      <br />
      {sortedLinks.map(({path, label}) => (
        <Box key={path} mb={1}>
          <Link to={path} className="link">
            {label}
          </Link>
        </Box>
      ))}
    </Box>
  );
};

export default Demo;
